export const CHILD_SIZE = {
  small: 'small',
  medium: 'medium',
} as const;

export const CHILD_WIDTH_RANGE = {
  small: { from: 18, to: 47 },
  medium: { from: 48, to: 9999 },
} as const;
